import { number } from 'prop-types'
import Textarea from 'react-textarea-autosize'
import Input from '../Input'

import './styles.scss'

export default class TextArea extends Input {
  static propTypes = {
    ...Input.propTypes,
    maxRows: number,
    minRows: number,
    tabIndex: number,
    textIndent: number, // pixel value
  }

  static defaultProps = {
    ...Input.defaultProps,
    inputType: 'textarea',
    minRows: 3,
    textIndent: 0,
  }

  get truncate() {
    if (
      !this.state.focused &&
      this.props.maxLength &&
      this.props.truncate &&
      this.remaining < 0
    ) {
      return `${this.props.value.slice(0, this.props.maxLength)}...`
    }

    return this.props.value
  }

  get icon() {
    return null
  }

  get inputElement() {
    return (
      <Textarea
        {...this.inputProps()}
        // input props above is not defined and does not effect the text area nested in this react component...
        // if replaced with `...this.props` the component presents incorrectly.
        // As a fix I'm pulling autoFocus from pops values used throughout the application.
        // autoFocus and focusOnMount are both widely used.
        // A more foundational solution would involve refactoring the application to spread values passed.
        autoFocus={this.props.autoFocus || this.props.focusOnMount} // eslint-disable-line jsx-a11y/no-autofocus
        ref={(element) => this.trackInputElement(element)}
        value={this.truncate}
        placeholder={this.props.placeholder}
        minRows={this.props.minRows}
        maxRows={this.props.maxRows}
        tabIndex={this.props.tabIndex}
        style={{ textIndent: this.props.textIndent, ...this.props.style }}
      />
    )
  }
}
